import { ApiClient } from '../api-client';

/**
 *  LedgerApi is a singleton w/o interceptors(No Auth)
 * @returns {AxiosInstance}
 */
const LedgerApi = ApiClient.service.ledger;

/**
 *  UseLedgerApi is a hook that returns a reusable axios instance with auth
 * @returns {AxiosInstance}
 */
const useLedgerApi = () => {
  return LedgerApi;
};

export { LedgerApi, useLedgerApi };
